import axios from 'axios';

export async function sendLeadFormData(payload) {

  const res = await axios.get(process.env.REACT_APP_URL2 + '/api/window-sticker-lead-form?dealership=' + payload.subdomain + '&vin=' + payload.vin + '&firstName=' + payload.firstName + '&lastName=' + payload.lastName + '&email=' + payload.email + '&phone=' + payload.phone);
  return res.data.response;
}
